
<template>
  <div class="customer-content">
    <div class="customer-header">
      <h1>{{$_('customer_list_of')}} {{sCompany}}</h1>
    </div>
    <div class="customer-list">
      <CustomerList />
    </div>
  </div>
</template>

<script>
import CustomerList from "@/modules/client/components/CustomerList";

export default {
  name: "Customer",
  data() {
    return {
      sCompany: ""
    };
  },
  created() {
    let oCompany = JSON.parse(localStorage.getItem("company"));
    this.sCompany = oCompany.PLIBSOC;
  },
  components: {
    CustomerList
  }
};
</script>

<style scoped>
.customer-content {
  padding: 50px 30px;
}
.customer-header {
  margin-bottom: 40px;
  padding: 0px 15px;
}
.customer-list h2 {
  padding: 0px 15px;
  margin-bottom: 15px;
}
</style>